import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React, { useState } from "react";
import { BiCloudUpload, BiCopy, BiTrashAlt, BiX } from "react-icons/bi";
import {
  ContextMenuItem,
  useCustomContextMenu,
} from "src/components/UseContextMenu";

import {
  Workout,
  WorkoutTypeString,
} from "src/modules/fithub-shared/interfaces/workout";
import { createTemplate } from "../functions";

interface DraggableTabProps {
  key: string;
  selected: boolean;
  content: Workout;
  onClick: () => void;
  onDuplicate: (e: string) => void;
  onDelete: (e: Workout) => void;
}

const DraggableTab: React.FC<DraggableTabProps> = ({
  selected,
  content,
  onClick,
  onDuplicate,
  onDelete,
}) => {
  const menu = useCustomContextMenu();
  const [mouseIn, setMouseIn] = useState(false);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: content.id });

  const style = {
    minWidth: 100,
    zIndex: isDragging ? 100 : undefined,
    transform: CSS.Translate.toString(transform),
    transition,
  };

  const Duplicate = () => {
    onDuplicate(content.id);
  };

  const SaveTemplate = () => {
    createTemplate(content.id)
      .then(() => {
        //TODO: Adicionar Alerta (hook)
        //mostrarAlerta("Template Salvo!");
      })
      .catch((err) => {
        alert(err);
      });
  };

  const contextItems: ContextMenuItem[] = [
    {
      title: "Duplicar",
      icon: BiCopy,
      action: Duplicate,
    },
    {
      title: "Salvar como template",
      icon: BiCloudUpload,
      action: SaveTemplate,
    },
    {
      title: "Remover",
      icon: BiTrashAlt,
      action: () => onDelete(content),
    },
  ];

  const handleContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    menu.showContextMenu(e, contextItems);
  };

  return (
    <>
      <menu.ContextMenu />
      <div
        ref={setNodeRef}
        style={style}
        onContextMenu={handleContextMenu}
        className={`tab tab-button flex-row ${
          selected && "selected"
        } ${isDragging ? "cursor-grabbing" : ""}`}
        {...attributes}
        {...listeners}
        onMouseEnter={() => setMouseIn(true)}
        onMouseLeave={() => setMouseIn(false)}
      >
        <div
          onClick={onClick}
          className="flex cursor-pointer flex-col px-2 hover:opacity-80"
        >
          <div
            className="flex h-7 items-center overflow-hidden"
            title={content.id}
          >
            <h1 className={`truncate text-sm font-bold`}>
              {`${content.cache ? "*" : ""}${content.title}`}
            </h1>
          </div>
          <span className="h-1" />
          <h2 className={`pb-1 text-xs uppercase`}>
            {WorkoutTypeString(content.type)} {content.order}
          </h2>
        </div>

        <div className="flex w-6 flex-shrink-0 items-center justify-center">
          <button>
            <BiX
              onClick={() => onDelete(content)}
              size={20}
              className={mouseIn ? "dark:text-white" : "text-transparent"}
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default DraggableTab;
